const locale = {
	DASHBOARDS: 'لوحات',
	MANAGETASTE: 'الأذواق',
	MANAGECATEGORIES: 'فئات',
	STORES: 'Stores',
	STOREREPORT: 'Store Report',
	UPLOADINVOICE: 'Upload FIle of Invoices',
	MANAGEPLACES:'جميع الأماكن',
	PLACE:'مكان',
	MANAGECUSTOMERSPLACES:'أضيفت من قبل العملاء',
	CLAIMREQUESTS:'يطالب بها أصحابها',
	MANAGECUSTOMERS:'عملاء',
	MANAGEOWNERS:'أصحاب',
	MANAGEFEATURES:'سمات',
	MANAGEFAQPAGE:'التعليمات',
	MANAGEEVENTS:'الأحداث',
	MANAGEORDERS:'طلبات الطعام',
	MANAGELANGUAGE:'لغة',
	MANAGENEWSLATTER:'النشرة الإخبارية',
	MANAGESTATICPAGE:'صفحات المحتوى',
	MANAGETERMS:'مصطلحات',
	SUGGETIONEDIT:'التعديلات المقترحة من قبل العملاء',
	CLAIMREQUESTSCUSTOMER:'يطالب بها العملاء',
	REPORTED:'أبلغت من قبل العملاء'
};

export default locale;
